import { Box } from '@mentimeter/ragnar-ui/box';
import { WordCloud } from '@mentimeter/visualizations-react/visualizations/word-cloud';
import { FullSizeContainer } from '@mentimeter/visualizations-react/utils/full-size-container';
import { useRagnar } from '@mentimeter/ragnar-react';

interface WordCloudVisualizationProps {
  shouldAnimate: boolean;
  shouldHideResults: boolean;
  results: Array<{
    text: string;
    value: number;
  }>;
}

export const WordCloudVisualization = ({
  shouldAnimate,
  shouldHideResults,
  results,
}: WordCloudVisualizationProps) => {
  const {
    theme: {
      visualizationColors: { fillColors, textColor },
      fonts: { body },
    },
  } = useRagnar();

  const colors = fillColors.length > 0 ? fillColors : [textColor];

  return (
    <Box width="100%" height="100%" px="4%">
      <FullSizeContainer>
        {(width, height) => (
          <WordCloud
            width={width}
            height={height}
            colors={colors as [string, ...[string]]}
            textColor={textColor}
            data={results}
            staticOptions={results}
            fontFamily={body}
            disableAnimations={!shouldAnimate}
            shouldMaskWords={shouldHideResults}
          />
        )}
      </FullSizeContainer>
    </Box>
  );
};
